import { Input,Button } from 'antd';
import { FilterFilled, SearchOutlined } from '@ant-design/icons';
import moment from 'moment';

export const getSearchFilter = (dataIndex, title) => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8, width: 204 }}>
      <Input
        autoFocus
        placeholder={`Search ${title}`}
        value={selectedKeys[0]}
        onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => confirm()}
        style={{ marginBottom: 8, display: 'block' }}
      />
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button type="primary" size="small" style={{width:90}} onClick={() => confirm()} icon={<SearchOutlined />}>
          Search
        </Button>
        <Button size="small" style={{width:90}} onClick={() => { clearFilters?.(); confirm(); }}>
          Reset
        </Button>
      </div>
    </div>
  ),
  filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? '#1890ff' : '' }} />,
  onFilter: (value, record) => {
    const fieldValue = dataIndex
      .split(".")
      .reduce((obj, key) => obj?.[key], record);

    return fieldValue
      ?.toString()
      .toLowerCase()
      .includes(value.toLowerCase());
  },
});

export const getDropdownFilter = (dataIndex, data, getLabel = v => v) => {
  const uniqueValues = [
    ...new Set(data.map(item => item[dataIndex]).filter(v => v !== null && v !== undefined && v !== ''))
  ];

  return {
    filters: [
      ...uniqueValues.map(v => ({
        text: getLabel(v),
        value: v,
      })),
      { text: 'Show Empty Only', value: '__EMPTY__' }
    ],

    onFilter: (value, record) => {
      if (value === '__EMPTY__') {
        const v = record[dataIndex];
        return v === null || v === undefined || v === '';
      }
      return String(record[dataIndex]) === String(value);
    },

    filterIcon: filtered => (
      <FilterFilled style={{ color: filtered ? '#1890ff' : '' }} />
    )
  };
};

export const getDateSorter = (dataIndex) => ({
  sorter: (a, b) =>
    new Date(a[dataIndex]).getTime() - new Date(b[dataIndex]).getTime(),
  sortDirections: ['descend', 'ascend'],
});

export const getTimeSorter = (dataIndex) => ({
  sorter: (a, b) => {
    const parse = (str) => {
      if (!str) return 0;
      const m = moment(str, ["hh:mm A", "h:mm A"], true);
      return m.isValid() ? m.valueOf() : 0;
    };
    return parse(a[dataIndex]) - parse(b[dataIndex]);
  },
  sortDirections: ['descend', 'ascend'],
});

// Sorter for '0h 6m' style strings
export const getHoursSorter = (dataIndex) => ({
  sorter: (a, b) => {
    const parse = (str) => {
      if (!str) return 0;
      const match = str.match(/(\d+)h\s*(\d+)m/);
      if (!match) return 0;
      return parseInt(match[1], 10) * 60 + parseInt(match[2], 10);
    };
    return parse(a[dataIndex]) - parse(b[dataIndex]);
  },
  sortDirections: ['descend', 'ascend'],
});